import axios from "axios";
import { adminServerInstance } from "../axios/instances";
import { execute } from "../network/executor";
import { getUserPreference } from "../utilities/common";
import { INCIDENT_MANAGEMENT as type } from "./types";

/**
 * @param {Object} params
 * @param {number} params.from_date 
 * @param {number} params.to_date
 * @param {array} params.warehouse 
 * @param {array} params.partner_ids
 * @para
 */
export function searchCompensated(params) {   
  return function(dispatch) {
      dispatch({type: type.SEARCH_COMPENSATED_ORDER})
      return adminServerInstance.post(`/incident/compemsated/search`, params)
      .then(({data}) => {
          dispatch({
              type: type.SEARCH_COMPENSATED_ORDER_SUCCESS,
              payload: data.data
          })
          return Promise.resolve(data.data);
      }).catch(error => {
          dispatch({
              type: type.SEARCH_COMPENSATED_ORDERT_FAIL,
              payload: error
          })
          return Promise.reject(error);
      });
  }
}

/**
 * @param {Object} params
 * @param {number} params.from_date 
 * @param {number} params.to_date
 * @param {array} params.warehouse 
 * @param {array} params.partner_ids
 * @para
 */
export function searchMultipleTypeOrder(params) {   
  return function(dispatch) {
      dispatch({type: type.SEARCH_MULTIPLE_ORDER})
      return adminServerInstance.post(`/incident/multi/search`, params)
      .then(({data}) => {
          dispatch({
              type: type.SEARCH_MULTIPLE_ORDER_SUCCESS,
              payload: data.data
          })
          return Promise.resolve(data.data);
      }).catch(error => {
          dispatch({
              type: type.SEARCH_MULTIPLE_ORDER_FAIL,
              payload: error
          })
          return Promise.reject(error);
      });
  }
}
/**
 * @param {Object} params
 * @param {number} params.from_date 
 * @param {number} params.to_date
 * @param {array} params.warehouse 
 * @param {array} params.partner_ids
 * @para
 */
export function searchKeyAccount(params) {   
  return function(dispatch) {
      dispatch({type: type.SEARCH_KEY_ACCOUNT})
      return adminServerInstance.post(`/incident/keyaccount/search`, params)
      .then(({data}) => {
          dispatch({
              type: type.SEARCH_KEY_ACCOUNT_SUCCESS,
              payload: data.data
          })
          return Promise.resolve(data.data);
      }).catch(error => {
          dispatch({
              type: type.SEARCH_KEY_ACCOUNT_FAIL,
              payload: error
          })
          return Promise.reject(error);
      });
  }
}

/**
 * @param {Object} params
 * @param {int} params.id 
 * @param {string} params.name
 * @param {string} params.phone 
 * @param {string} params.email
 * @param {string} params.ding_talk_id 
 * @param {number} params.warehouse 
 * @param {array} params.partner_ids
 */
export function updateKeyAccount(params) {   
  return function(dispatch) {
      dispatch({type: type.UPDATE_KEY_ACCOUNT})
      return adminServerInstance.post(`/incident/keyaccount/update`, params)
      .then(({data}) => {
          dispatch({
              type: type.UPDATE_KEY_ACCOUNT_SUCCESS,
              payload: data.data
          })
          return Promise.resolve(data.data);
      }).catch(error => {
          dispatch({
              type: type.UPDATE_KEY_ACCOUNT_FAIL,
              payload: error
          })
          return Promise.reject(error);
      });
  }
}

/**
 * @param {Object} params
 * @param {string} params.name
 * @param {string} params.phone 
 */
export function deleteKeyAccount(params) {   
  return function(dispatch) {
      dispatch({type: type.DELETE_KEY_ACCOUNT})
      return adminServerInstance.post(`/incident/keyaccount/delete`, params)
      .then(({data}) => {
          dispatch({
              type: type.DELETE_KEY_ACCOUNT_SUCCESS,
              payload: data.data
          })
          return Promise.resolve(data.data);
      }).catch(error => {
          dispatch({
              type: type.DELETE_KEY_ACCOUNT_FAIL,
              payload: error
          })
          return Promise.reject(error);
      });
  }
}

export function createKeyAccount(params) {   
  return function(dispatch) {
      dispatch({type: type.CREATE_KEY_ACCOUNT})
      return adminServerInstance.put(`/incident/keyaccount/create`, {...params})
      .then(({data}) => {
          dispatch({
              type: type.CREATE_KEY_ACCOUNT_SUCCESS,
              payload: data.data
          })
          return Promise.resolve(data.data);
      }).catch(error => {
          dispatch({
              type: type.CREATE_KEY_ACCOUNT_FAIL,
              payload: error
          })
          return Promise.reject(error);
      });
  }
}

export const getAllDropDownFields = () => (dispatch) => execute(dispatch)(
  adminServerInstance.get('/incident/fields'),
  {
    type: type.GET_ALL_DROP_DOWNS,
    success: type.GET_ALL_DROP_DOWNS_SUCCESS,
    fail: type.GET_ALL_DROP_DOWNS_FAIL,
  }
);

/**
 * 
 * @param {Object} params - combined object to send for server processing
 * @param {number} params.level - Incident level
 * @param {number} params.recorded_by - ID of the employee
 * @param {number} params.incident_date - The timestamp of the current date
 * @param {string} params.tracking_no - Tracking number of the incident
 * @param {number} params.occurrence_date - The timestamp of the date that the incident occurred
 * @param {number} params.source - Source type of the incident
 * @param {number} params.incident_type - Type of the incident
 * @param {number} params.action_required_type - Type of the action that is required to fix
 */
export const createNewInvestigation = (params) => (dispatch) => execute(dispatch)(
  adminServerInstance.post('/incident/create', {...params}),
  {
    type: type.CREATE_NEW_INCIDENT,
    success: type.CREATE_NEW_INCIDENT_SUCCESS,
    fail: type.CREATE_NEW_INCIDENT_FAIL
  }
)

/**
 * 
 * @param {Object} params - combined object to send for server processing
 * @param {number} params.level - Incident level
 * @param {string} params.tracking_no - Tracking number of the incident
 * @param {number} params.occurrence_date - The timestamp of the date that the incident occurred
 * @param {number} params.source - Source type of the incident
 * @param {number} params.incident_type - Type of the incident
 * @param {number} params.action_required_type - Type of the action that is required to fix
 */
export const updateNewInvestigation = (incidentId, params) => (dispatch) => execute(dispatch)(
  adminServerInstance.put(`/incident/create/${incidentId}`, {...params}),
  {
    type: type.UPDATE_BASIC_INCIDENT,
    success: type.UPDATE_BASIC_INCIDENT_SUCCESS,
    fail: type.UPDATE_BASIC_INCIDENT_FAIL
  }
)

/**
 * @param {number} incidentId
 * @param {Object} params - combined object to send for server processing
 * @param {number} params.handler - The staff id assigned to this incident
 * @param {number} params.caused_by - Id of caused by category
 * @param {number} [params.caused_by_detail] - Written message when caused_by requires input
 * @param {number} params.root_cause - Id of root cause category
 * @param {number} [params.root_cause_detail] - Written message when root_cause requires input
 * @param {number} params.result_type - Result type
 * @param {number} [params.result_detail] - Written message when result_type requires input
 * @param {number} params.action_result - Action result type
 * @param {string} [params.action_result_detail] - Written message when action_result requires input
 * @param {number} [params.action_result_date] - The timestamp the action is taken when action_result requires input
 * @param {number} params.corrective_action - Action taken to fix the incident
 * @param {number} params.corrective_action_detail - Written message when corrective_action requires input
 * @param {number} [params.notes]
 */
export const updateInprogressInvestigation = (incidentId, params) => (dispatch) => execute(dispatch)(
  adminServerInstance.put(`/incident/inprogress/${incidentId}`, {...params}),
  {
    type: type.UPDATE_INPROGRESS_INCIDENT,
    success: type.UPDATE_BASIC_INCIDENT_SUCCESS,
    fail: type.UPDATE_INPROGRESS_INCIDENT_FAIL
  }
)

/**
 * @param {number} incidentId
 * @param {Object} params - combined object to send for server processing
 * @param {number} params.close_time - The timestamp of this action
 * @param {number} params.review_type - Type id of the review type
 * @param {number} params.consignee_refund 
 * @param {number} params.client_refund
 * @param {number} [params.notes]
 */
export const closeInvestigation = (incidentId, params) => (dispatch) => execute(dispatch)(
  adminServerInstance.put(`/incident/close/${incidentId}`, {...params}),
  {
    type: type.CLOSE_INVESTIGATION,
    success: type.CLOSE_INVESTIGATION_SUCCESS,
    fail: type.CLOSE_INVESTIGATION_FAIL
  }
)

/**
 * 
 * @param {Object} query - Combined object to send for server processing
 * @param {number} query.form_date - Timestamp from date
 * @param {number} query.to_date - Timestamp to date
 * @param {number} [query.status] - The Investigation status
 * @param {number} [query.source] - The source category
 * @param {number} query.location - Branch/warehouse ID
 * @param {number} [query.handler] - The assigned staff ID
 * @param {string} [query.id] - Investigation number, will only return one result
 * @param {string} [query.tracking_no] - Tracking number of the parcel
 * @param {number} [query.page = 1] - Current page
 * @param {number} [query.rows = 20] - Returned rows per page
 * @param {number} [query.incident_type] - Returned rows per page
 * @param {number} [query.driver_id] - Returned rows per page
 */
export const searchIncidents = (query) => (dispatch) => execute(dispatch)(
  adminServerInstance.get('/incident/search', {
    params: query
  }),
  {
    type: type.GET_INVESTIGATIONS,
    success: type.GET_INVESTIGATIONS_SUCCESS,
    fail: type.GET_INVESTIGATIONS_FAIL
  }
)

/**
 * 
 * @param {number} recordedBy - Staff id of the person uploading the file
 * @param {file} file - The excel file
 * @param {function} onUploadProgress - an event emitter for upload progress
 */
export const batchUploadIncidents = (recordedBy, file, onUploadProgress) => {
  let formData = new FormData();
  formData.append('incidents', file);
  formData.append('recorded_by', recordedBy);

  return adminServerInstance.post(
    '/incident/batch/create',
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      timeout: 0,
      onUploadProgress,
    }
  );
}

/**
 * 
 * @param {Object} params - Combined object to send for server processing
 * @param {number} params.from_date - Timestamp from date
 * @param {number} params.to_date - Timestamp to date
 * @param {number} [params.status] - The Investigation status
 * @param {number} [params.source] - The source category
 * @param {number} params.location - Branch/warehouse ID
 * @param {number} [params.handler] - The assigned staff ID
 * @param {string} [params.id] - Investigation number, will only return one result
 * @param {string} [params.tracking_number] - Tracking number of the parcel
 */
export const downloadIncidentExcel = (params) => {
  console.log(getUserPreference().authToken)
  return axios.get(`${process.env.REACT_APP_MAP_SERVER_URL}/incident/batch/download`, {
    params,
    responseType: 'blob',
    headers: {
      'Authorization': `Bearer ${getUserPreference().authToken}`
    }
  })
}

/**
 * 
 * @param {number} [warehouseId] - The warehouse id of the query. Leave blank for all
 */
export const getIncidentCount = (warehouseId) => (dispatch) => execute(dispatch)(
  adminServerInstance.get(`/incident/count/warehouse${warehouseId ? `/${warehouseId}` : ""}`),
  {
    type: type.GET_WAREHOUSE_INCIDENT_COUNT,
    success: type.GET_WAREHOUSE_INCIDENT_COUNT_SUCCESS,
    fail: type.GET_WAREHOUSE_INCIDENT_COUNT_FAIL
  }
)

/**
 * @param {Object} params - combined object to send for server processing
 * @param {number} params.close_by - The timestamp of this action
 * @param {number} params.review_type - Type id of the review type
 * @param {array} incident_ids - Array of incident ids to close
 */
export const batchCloseIncident = (params) => (dispatch) => execute(dispatch)(
  adminServerInstance.put('/incident/batch/close', {...params}),
  {
    type: type.BATCH_CLOSE_INCIDENT,
    success: type.BATCH_CLOSE_INCIDENT_SUCCESS,
    fail: type.BATCH_CLOSE_INCIDENT_FAIL
  }
)

/**
 * @param {Object} params - combined object to send for server processing
 * @param {number} params.handler - The timestamp of this action
 * @param {number} params.caused_by - Type id of the cause by type
 * @param {number} params.caused_by_detail - Type id of the cause detail type
 * @param {number} params.root_cause - Type id of the root cause type
 * @param {number} params.root_cause_detail - Type id of the root caused detail type
 * @param {number} params.result_type - Type id of the result type
 * @param {number} params.result_detail - Type id of the result type type
 * @param {number} params.corrective_action - Type id of the corrective action type
 * @param {number} params.corrective_action_detail - Type id of the corrective action detail type
 * @param {string} params.notes - notes
 * @param {array} incident_ids - Array of incident ids to close
 */
 export const batchInprogressIncident = (params) => (dispatch) => execute(dispatch)(
  adminServerInstance.put('/incident/batch/progress', {...params}),
  {
    type: type.BATCH_PROGRESS_INCIDENT,
    success: type.BATCH_PROGRESS_INCIDENT_SUCCESS,
    fail: type.BATCH_PROGRESS_INCIDENT_FAIL
  }
)